/**
 * @author zk
 * @description 记录用户日志
 * @Date 2019/12/28
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;


class AuthUserLog extends WizContainer {
  componentName = 'authUserLog';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  // _handleCMD(nextProps, nextState, key) {
  //   let o = nextProps[key]
  //   if (o['success']) {
  //     wizNotice.success(o['msg'])
  //     return true;
  //   } else {
  //     wizNotice.error(o['msg'])
  //     return false;
  //   }
  // }


  // _handleFile(nextProps, nextState, key) {
  //   let o = nextProps[key]
  //   let columnDefs = [
  //     {
  //       headerName: '',
  //       width: 30,
  //       field: 'rowIndex',
  //       hidden: true,
  //       suppressMovable: true,
  //       cellStyle: {
  //         textAlign: 'center',
  //         padding: '5px 0',
  //         color: '#595959',
  //         backgroundColor: '#f0f0f0',
  //         display: 'inline-flex',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         fontWeight: '500',
  //         boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
  //       },
  //     },
  //     {
  //       headerName: '配置key',
  //       field: 'configKey',
  //       width: 20,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     },
  //     {
  //       headerName: '配置内容',
  //       field: 'configValue',
  //       width: 15,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     },
  //     {
  //       headerName: '备注',
  //       field: 'remarks',
  //       width: 50,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     },
  //     {
  //       headerName: '状态',
  //       field: 'converterState',
  //       width: 15,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     },
  //     // {
  //     //   headerName: '创建人',
  //     //   field: 'createBy',
  //     //   width: 15,
  //     //   cellStyle: {
  //     //     textAlign: 'center',
  //     //   },
  //     //   style: {
  //     //     alignment: { vertical: 'bottom', horizontal: 'left' },
  //     //   },
  //     // },
  //     {
  //       headerName: '创建时间',
  //       field: 'createTime',
  //       width: 20,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     },
  //     // {
  //     //   headerName: '修改人',
  //     //   field: 'updateBy',
  //     //   width: 15,
  //     //   cellStyle: {
  //     //     textAlign: 'center',
  //     //   },
  //     //   style: {
  //     //     alignment: { vertical: 'bottom', horizontal: 'left' },
  //     //   },
  //     // },
  //     {
  //       headerName: '修改时间',
  //       field: 'updateTime',
  //       width: 20,
  //       cellStyle: {
  //         textAlign: 'center',
  //       },
  //       style: {
  //         alignment: { vertical: 'bottom', horizontal: 'left' },
  //       },
  //     }
  //   ]
  //   if (o['success']) {
  //     let data = o['data']
  //     WizBrowserExport({
  //       title: '公共配置',
  //       sheetName: 'positionInfo',
  //       columns: columnDefs.filter((_, index) => index),
  //       rows: data,
  //       filename: '公共配置信息.xlsx',
  //     })
  //     // wizNotice.success(o['msg'])
  //     return true;
  //   } else {
  //     wizNotice.error(o['msg'])
  //     return false;
  //   }
  // }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      // apiDataFormat: {
      //   // export: this._handleFile
      // },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(AuthUserLog);
